module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_5.e55cf1c3.png";